
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: 'ApplyUnitDialog',
  components: {},
})
export default class ApplyUnitDialog extends Vue {
  @Prop({type: Boolean}) isMaterial!: any;
}
